up.compiler('#cookieConsent', (element: HTMLElement) => {
    const handler = (ev: Event) => {
        Cookiebot.show();
    };

    element.addEventListener('click', handler);

    return () => {
        element.removeEventListener('click', handler);
    }
});